import React from 'react';
import classes from './Loader.module.scss';
import Logo from '../../UI/Logo/Logo';

const Loader = (props) => (    
    // <div className={classes['lds-ellipsis']}><div></div><div></div><div></div><div></div></div>    

    <div style={{
        width: "100%", 
        justifyContent : "start",
        textAlign:"center",
        paddingTop: "40px"
        }}>
        {props.showLogo && <Logo />} 
        <div style={{width:"100%"}}>
            <div style={{fontFamily : "Rubik", fontWeight: "700", marginBottom: "15px", marginTop: "160px", textAlign: "center", color: "white", fontSize: "27px"}}>Loading</div>
            <div style={{width: "100%", textAlign: "center"}}>
                <div className={classes.spinner}></div>
            </div>
        </div>
    </div>
    );

export default Loader